// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"ef3782bc","410":"66a0d661","564":"bd9fc08c"}[chunkId] + ".chunk.css";
};